import { computed, makeObservable } from 'mobx';

import InvoiceDetailsStore from '../InvoiceDetailsStore';
import UnsettledReceivablesStore from '../UnsettledReceivablesStore';

export default class InvoiceDetailsFooterViewStore {
  constructor(
    private invoiceDetailsStore: InvoiceDetailsStore,
    private unsettledReceivablesStore: UnsettledReceivablesStore
  ) {
    makeObservable(this);
  }

  @computed
  public get showFooter(): boolean {
    const payload = this.invoiceDetailsStore.invoiceDetails.payload;

    return !!payload && (payload.status === 'OK' || payload.status === 'TOO_LARGE');
  }

  @computed
  public get showPaymentButton(): boolean {
    if (this.invoiceDetailsStore.invoiceDetailsRequest.contentType === 'PENALTY') {
      return false;
    }

    return this.unsettledReceivablesStore.unpaidInvoice(this.invoiceDetailsStore.currentInvoiceNumber) != null;
  }
}
